<template>
  <div class="box-pwd">
    <div class="pwd-wrap">
      <input
        type="text"
        class="pwd-phone"
        v-model="params.account"
        placeholder="绑定手机号"
        disabled
      />
    </div>

    <div class="pwd-wrap">
      <input
        type="text"
        class="pwd-nunber"
        v-model="params.captcha"
        placeholder="请输入验证码"
      />
      <span :class="{ disabled: isCounting }" @click="handleGetCode">
        {{ countdownText }}
      </span>
    </div>

    <div class="pwd-wrap">
      <input
        type="password"
        class="pwd-pwd"
        v-model="params.password"
        placeholder="请输入新密码"
      />
    </div>

    <div class="pwd-wrap">
      <input
        type="password"
        class="pwd-pwd-confirm"
        v-model="params.password2"
        placeholder="请再次确认密码"
      />
    </div>

    <div class="pwd-send" @click="handleSend">提交</div>
  </div>
</template>

<script>
import { registerVerify } from "@/api/Login";
import { registerReset } from "@/api/UserCenter";

export default {
  name: "Pwd",
  props: {
    userObj: Object,
  },
  data() {
    return {
      params: {
        account: "",
        captcha: "",
        password: "",
        password2: "",
      },
      countdown: 60,
      timer: null,
      isCounting: false,
    };
  },
  watch: {
    userObj: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return;
        this.params.account = newVal.phone || "";
      },
    },
  },
  computed: {
    countdownText() {
      return this.isCounting ? `${this.countdown}秒后重新获取` : "获取验证码";
    },
  },
  methods: {
    isMobile(value) {
      return /^1[3-9][0-9]\d{8}$/.test(value);
    },
    handleSend() {
      const signInParams = this.params;
      if (!this.isMobile(signInParams.account)) {
        this.$message.error("当前账号手机号无效");
        return;
      }
      if (!signInParams.captcha) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!signInParams.password) {
        this.$message.error("请输入新密码");
        return;
      }
      if (!signInParams.password2) {
        this.$message.error("请再次确认密码");
        return;
      }
      if (signInParams.password !== signInParams.password2) {
        this.$message.error("两次密码不一致");
        return;
      }

      const payload = JSON.parse(JSON.stringify(signInParams));
      delete payload.password2;

      registerReset(payload)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg || "密码修改成功");
            return;
          }
          this.$message.error(res.msg || "密码修改失败");
        })
        .catch((err) => {
          this.$message.error(err?.msg || "密码修改失败");
        });
    },
    getCode() {
      if (!this.isMobile(this.params.account)) {
        this.$message.error("请输入正确的手机号");
        return Promise.resolve(false);
      }

      return registerVerify({
        phone: this.params.account,
        type: "login",
      })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg || "验证码发送成功");
            return true;
          }
          this.$message.warning(res.msg || "验证码发送失败");
          return false;
        })
        .catch((err) => {
          this.$message.error(err?.msg || "验证码发送失败");
          return false;
        });
    },
    async handleGetCode() {
      if (this.isCounting) return;
      const ok = await this.getCode();
      if (ok) {
        this.startCountdown();
      }
    },
    startCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.isCounting = true;
      this.countdown = 60;

      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.stopCountdown();
          return;
        }
        this.countdown -= 1;
      }, 1000);
    },
    stopCountdown() {
      clearInterval(this.timer);
      this.timer = null;
      this.isCounting = false;
      this.countdown = 60;
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss">
.box-pwd {
  padding-top: 30px;
  .pwd-wrap {
    height: 36px;
    margin-bottom: 19px;
    input {
      box-sizing: border-box;
      padding: 0;
      margin: 0;
      width: 319px;
      height: 36px;
      line-height: 36px;
      background: transparent;
      border: 1px solid #f2f2f2;
      border-radius: 6px;
      text-indent: 12px;
    }
    span {
      font-size: 13px;
      color: #3fbce9;
      margin-left: 17px;
      cursor: pointer;
      &.disabled {
        color: #b4b4b4;
        cursor: not-allowed;
      }
    }
    .pwd-phone {
      background-color: #3fbce916;
      color: #3fbce9;
    }
    .pwd-nunber {
      width: 196px;
    }
  }
  .pwd-send {
    width: 55px;
    height: 32px;
    line-height: 32px;
    background: #3fbce9;
    color: #fff;
    font-size: 13px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
